import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-game-section" }
const _hoisted_2 = { class: "game-filter-wrap" }
const _hoisted_3 = { class: "game-menu-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "game-menu-name" }
const _hoisted_7 = {
  key: 0,
  class: "provider-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }

import { ref, watch, onMounted, computed, nextTick, onUnmounted } from 'vue';
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia';
import { useUserStore, useGameStore } from "@/store";
import { useHelpTool } from '@/hooks';
import { queryGameProvider, queryGameList, queryGameHot, queryGameNew,
  queryGameCollect, collectGame, cancelCollectGame } from "@/api";


export default {
  __name: 'GameSection',
  props: ['menuFixed'],
  setup(__props) {

const props = __props

const HOT_LIST = [
  { code: 'HOT', name: 'HOT', icon: require('@/assets/img/game/hot-text.png') },
  { code: 'NEW', name: 'NEW', icon: require('@/assets/img/game/new-text.png') },
  { code: 'LIKE', name: 'LIKE', icon: require('@/assets/img/game/like-text.png') },
];

const router = useRouter()
const { doEnterGame } = useHelpTool()

const userStore = useUserStore();
const gameStore = useGameStore();
const { gameMenu, activeGameMenu } = storeToRefs(gameStore);

const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const dataList = ref([]);
const current = ref(1);
const pageSize = ref(12);

const providerList = ref([]);
const activeProvider = ref(null);
const searchText = ref('');

const hasLogin = computed(() => {
  return !!userStore.uid;
})

watch(gameMenu, (newValue, oldValue) => {
  // console.log('gameMenu watch: ', newValue)
  if (newValue && newValue.length > 0) {
    gameStore.changeMenu(newValue[0]);
  }
})
  
watch(activeGameMenu, (newValue, oldValue) => {
  // console.log('activeGameMenu watch: ', newValue)
  if (newValue && newValue.showProvider) {
    fetchGameProvider();
  } else {
    providerList.value = [];
    activeProvider.value = null;
    reloadData();
  }
})

watch(activeProvider, (newValue, oldValue) => {
  if(newValue) {
    reloadData();
  }
})

onMounted(() => {
  gameStore.clearActiveMenu();
})

nextTick(() => {
  if (gameMenu.value.length > 0) {
    gameStore.changeMenu(gameMenu.value[0]);
  }
})

const fetchGameProvider = () => {
  if (activeGameMenu.value.code === 'hot') {
    let hotList = HOT_LIST || [];
    if(!hasLogin.value) {
      hotList = hotList.filter(item => item.code != 'LIKE');
    }
    providerList.value = hotList;
    activeProvider.value = providerList.value[0];
    return false;
  }
  queryGameProvider({
    type: activeGameMenu.value.code,
    hasLogin: hasLogin.value
  }).then(res => {
    providerList.value = res.data || [];
    if (providerList.value.length > 0) {
      activeProvider.value = providerList.value[0]
    } else {
      activeProvider.value = null;
      finished.value = false;
      refreshing .value= true;
      loadData();
    }
  });
}

const fetchGameList = () => {
  let doPost = queryGameList;
  if (!activeGameMenu.value) {
    return;
  }
  if (activeGameMenu.value?.code === 'hot') {
    let providerCode = activeProvider.value?.code;
    if(providerCode === 'HOT') {
      doPost = queryGameHot;
    } else if (providerCode === 'NEW') {
      doPost = queryGameNew;
    } else if (providerCode === 'LIKE') {
      doPost = queryGameCollect;
    }
  }
  doPost({
    pageSize: pageSize.value,
    current: current.value,
    type: activeGameMenu.value?.code,
    manuf: activeProvider.value?.code,
    hasLogin: hasLogin.value
  }).then(res => {
    dataList.value = dataList.value.concat(res.data || []);
    if (res.total <= res.page * pageSize.value) {
      finished.value = true;
    } else {
      current.value = res.page + 1;
    }
    loading.value = false;
  });
}

const loadData = () => {
  if (refreshing.value) {
    dataList.value = [];
    current.value = 1;
    refreshing.value = false;
  }
  fetchGameList();
}

const refreshData = () => {
  // 清空列表数据
  finished.value = false;
        
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  loadData();
  // accountStore.fetchBalance();
}

const reloadData = () => {
  finished.value = false;
  refreshing.value = true;
  loadData();
}

const toggleCollect = (game) => {
  let doPost = collectGame;
  if (game.isCollect) {
    doPost = cancelCollectGame;
  }
  doPost({
    gid: game.gid,
  }).then(res => {
    if(activeProvider.value?.code === 'LIKE') {
      reloadData();
    } else {
      dataList.value = dataList.value.map(item => {
        if(item.id == game.id) {
          item.isCollect = !item.isCollect;
        }
        return item;
      })
    }
  })
}


const goToSearchHistory = () => {
  router.push({ name: 'gameSearchHistory' });
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameMenu), (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["game-menu-item", { 'active': _unref(activeGameMenu) && _unref(activeGameMenu).code === item.code }]),
            key: item.code,
            onClick: $event => (_unref(gameStore).changeMenu(item))
          }, [
            _createElementVNode("img", {
              class: "game-menu-icon",
              src: require(`@/assets/img/game/type/${item.code}.png`)
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name.toUpperCase()) + " GAMES", 1)
          ], 10, _hoisted_4)), [
            [_directive_audio]
          ])
        }), 128))
      ]),
      (_unref(activeGameMenu) && _unref(activeGameMenu).showProvider && providerList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providerList.value, (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`provider-item ${activeProvider.value && activeProvider.value.code === item.code ? 'active' : 'inactive'}`),
                key: item.id,
                onClick: $event => (activeProvider.value = item)
              }, [
                _createVNode(_component_van_image, {
                  class: "provider-icon",
                  fit: "contain",
                  src: item.icon
                }, null, 8, ["src"])
              ], 10, _hoisted_8)), [
                [_directive_audio]
              ])
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["scroll-view", { 'with-provider': _unref(activeGameMenu) && _unref(activeGameMenu).showProvider }])
    }, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((refreshing).value = $event)),
        onRefresh: refreshData
      }, {
        default: _withCtx(() => [
          (dataList.value.length > 0)
            ? (_openBlock(), _createBlock(_component_van_list, {
                key: 0,
                loading: loading.value,
                "onUpdate:loading": _cache[0] || (_cache[0] = $event => ((loading).value = $event)),
                class: _normalizeClass(`game-list style${_unref(activeGameMenu).showType} ${__props.menuFixed ? 'fixed' : ''}`),
                finished: finished.value,
                "finished-text": _ctx.$t('common.noMore'),
                onLoad: loadData
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "game-block",
                      key: item.id
                    }, [
                      _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                        class: "game-img",
                        fit: "cover",
                        src: (_unref(activeGameMenu).showType === 0 ? item.icon : _unref(activeGameMenu).showType === 1 ? item.imgVertical : item.imgHorizontal) || '-',
                        "error-icon": require('@/assets/img/game/game.png'),
                        onClick: $event => (_unref(doEnterGame)({ gid: item.gid }))
                      }, {
                        loading: _withCtx(() => [
                          _createVNode(_component_van_loading, {
                            type: "spinner",
                            color: "#ADB5BF",
                            size: "24"
                          })
                        ]),
                        _: 2
                      }, 1032, ["src", "error-icon", "onClick"])), [
                        [_directive_audio]
                      ]),
                      (hasLogin.value)
                        ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                            key: 0,
                            class: "like-icon",
                            src: require(`@/assets/img/game/like${item.isCollect ? 'd' : ''}.png`),
                            onClick: $event => (toggleCollect(item))
                          }, null, 8, ["src", "onClick"])), [
                            [_directive_audio]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "blank-block" }, null, -1))
                ]),
                _: 1
              }, 8, ["loading", "class", "finished", "finished-text"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_van_empty, {
                  description: _ctx.$t('common.noData')
                }, null, 8, ["description"])
              ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2)
  ]))
}
}

}